<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { format as formatDate } from 'date-fns';

  import { SparkChart } from '@client/components/charts';
  import { Spinner } from '@client/components/spinner';

  import { AssetsService } from '@client/services/assets';

  import { updateTimelineData } from '@client/utils/document-report';

  export let row = {};
  export let props = {};

  let loading = false;

  let metrics = {
    sent: {
      color: '#43A0FC',
      label: $format('label.DELIVERED'),
      data: []
    },
    viewed: {
      color: '#D9BC61',
      label: $format('label.VIEWED'),
      data: []
    },
    downloaded: {
      color: '#92E2C0',
      label: $format('label.DOWNLOADED'),
      data: []
    }
  };

  const styles = 'border-width: 2px; color: #0087ff; height: 16px; width: 16px;';

  const generateMetricDataset = (series, label, color) => {
    const labels = [];
    const points = [];

    series.forEach(([x, y]) => {
      labels.push(formatDate(x, 'EEE, MMM d yyyy'));
      points.push(y);
    });

    if (series?.length) {
      return {
        labels,
        datasets: [
          {
            label,
            backgroundColor: 'rgba(225, 204,230, .1)',
            borderColor: color,
            pointColor: color,
            fill: true,
            tension: 0.3,
            data: points
          }
        ]
      };
    }

    return null;
  };

  const update = async () => {
    loading = true;

    const id = row.rulename;

    if (!props.metricsCache[id]) {
      const response = await AssetsService.getDocumentMetrics(row._id, row.hash, 365);

      const data = updateTimelineData(response);

      metrics.sent.data = generateMetricDataset(data.sentSeries, metrics.sent.label, metrics.sent.color);
      metrics.viewed.data = generateMetricDataset(data.viewedSeries, metrics.viewed.label, metrics.viewed.color);
      metrics.downloaded.data = generateMetricDataset(
        data.downloadedSeries,
        metrics.downloaded.label,
        metrics.downloaded.color
      );

      props.metricsCache[id] = metrics;
      props.onUpdate(props.metricsCache);
    } else {
      metrics = { ...props.metricsCache[id] };
    }

    loading = false;
  };

  onMount(async () => await update());

  $: data = props.metricsCache[row.rulename] || metrics;
</script>

<div class="charts">
  {#each Object.entries(data) as [key, config]}
    <div class="chart">
      <h3>{config.label}</h3>
      {#if !loading}
        <SparkChart bind:data={config.data} height="25px" />
      {:else}
        <Spinner show inline {styles} />
      {/if}
    </div>
  {/each}
</div>

<style lang="scss">
  .charts {
    align-items: center;
    display: grid;
    grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr) minmax(100px, 1fr);
    gap: 24px;

    .chart {
      height: 30px;
      max-width: 100px;
      position: relative;

      :global(.spinner) {
        justify-content: flex-start;
      }

      &:hover {
        z-index: 10;
      }

      h3 {
        font-size: var(--font-size-medium);
      }
    }
  }
</style>
